export class Translations {
  [key: string]: string;

  eCHello = '';
  eCConfirmationOrder = '';
  eCdoneInEstablishment = '';
  eCdeliveryProduct = '';
  eCvoucherAttachment = '';
  eCthankYouForChoosingDreampay = '';

  eOgreetings = '';
  eOimportantObs = '';
  eOemailAutomatic = '';
  eOinCaseNoVoucher = '';
  eOinCaseNoPurchase = '';

  eEforEstablishment = '';
  eEyourClientPurchased = '';
  eEgiveProductsToCustomer = '';
  eEvoucherAttached = '';
  eEexperienceSeeYouSoon = '';
  emailSubjectString = '';
}
